import { createSlice } from "@reduxjs/toolkit";

import { fetchProposalRecentActivity } from "./actions";

const DEFAULT_ERROR = "Failed to load recent activity";

const proposalRecentActivitySlice = createSlice({
  name: "proposalRecentActivity",
  initialState: { data: null, isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchProposalRecentActivity.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchProposalRecentActivity.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchProposalRecentActivity.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message ?? DEFAULT_ERROR;
      });
  },
});

export default proposalRecentActivitySlice.reducer;
